// Utility functions for maintenance mode management

/**
 * Toggle maintenance mode programmatically
 * Note: This requires a backend API to persist the state
 * For now, it's just a local state example
 */
export const toggleMaintenanceMode = () => {
  // In a real implementation, this would make an API call
  // to update the maintenance mode status on the server
  console.log('Maintenance mode toggle requested');
  console.log('Current mode can be changed in /src/services/api.js');
  console.log('Set MAINTENANCE_MODE = true/false');
};

/**
 * Get current maintenance status
 */
export const getMaintenanceStatus = () => {
  // Import the current status from api.js
  const { isMaintenanceMode } = require('../services/api');
  return isMaintenanceMode();
};

/**
 * Format maintenance messages
 */
export const formatMaintenanceMessage = (type = 'default') => {
  const messages = {
    default: {
      title: 'SYSTEM MAINTENANCE IN PROGRESS',
      subtitle: 'Combat systems are currently undergoing maintenance.',
      details: 'Weapon system calibration in progress.'
    },
    update: {
      title: 'SYSTEM UPDATE IN PROGRESS',
      subtitle: 'Installing new combat protocols.',
      details: 'Enhanced neural processing and improved weapon systems loading...'
    },
    security: {
      title: 'SECURITY PROTOCOL ACTIVE',
      subtitle: 'System lockdown initiated for security maintenance.',
      details: 'Firewall reconfiguration and threat detection systems updating...'
    },
    emergency: {
      title: 'EMERGENCY MAINTENANCE MODE',
      subtitle: 'Critical system repairs in progress.',
      details: 'Core systems offline. Emergency protocols activated.'
    }
  };

  return messages[type] || messages.default;
};

/**
 * Generate random system coordinates for display
 */
export const generateSystemCoords = () => {
  const lat = (Math.random() * 180 - 90).toFixed(4);
  const lng = (Math.random() * 360 - 180).toFixed(4);
  return `${lat}°${lat > 0 ? 'N' : 'S'} ${lng}°${lng > 0 ? 'E' : 'W'}`;
};

/**
 * Generate random access codes
 */
export const generateAccessCode = () => {
  const prefixes = ['MAINT', 'SYS', 'SEC', 'EMER', 'UPDT'];
  const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];
  const code = Math.floor(Math.random() * 9999).toString().padStart(4, '0');
  return `${prefix}-${code}`;
};

/**
 * Calculate estimated maintenance time
 */
export const getEstimatedMaintenanceTime = () => {
  // Random time between 30 minutes and 4 hours
//   const minutes = Math.floor(Math.random() * 210) + 30;
//   const hours = Math.floor(minutes / 60);
//   const remainingMinutes = minutes % 60;
  
//   if (hours === 0) {
//     return `${remainingMinutes} MINUTES`;
//   } else if (remainingMinutes === 0) {
//     return `${hours} HOUR${hours > 1 ? 'S' : ''}`;
//   } else {
//     return `${hours}H ${remainingMinutes}M`;
//   }
    return ('UNKNOWN TIME ESTIMATE');
};

export default {
  toggleMaintenanceMode,
  getMaintenanceStatus,
  formatMaintenanceMessage,
  generateSystemCoords,
  generateAccessCode,
  getEstimatedMaintenanceTime
};
